export default __webpack_public_path__ + "static/customers-5f7f71407e69d5cff67ecd6182de401f.png";